import Highcharts from 'highcharts';

import HC_more from 'highcharts/highcharts-more';
import HC_map from 'highcharts/modules/map';
import HC_wordCloud from 'highcharts/modules/wordcloud';
import HC_export from 'highcharts/modules/exporting';
import HC_data from 'highcharts/modules/data';
import HC_exportData from 'highcharts/modules/export-data';

// ! Important: initialize modules only once here!
HC_more(Highcharts);
HC_map(Highcharts);
HC_wordCloud(Highcharts);
HC_export(Highcharts);
HC_data(Highcharts);
HC_exportData(Highcharts);

Highcharts.setOptions({ accessibility: { enabled: false } });

// ! keep below for a while
// console.log('[Highcharts Shared] Instance initialized:', {
//   hasMapChart: typeof Highcharts.mapChart === 'function',
//   hasChart: typeof Highcharts.chart === 'function',
//   mapChartType: typeof Highcharts.mapChart,
// });

// ! export the SINGLE SHARED Instance
export { Highcharts };
